import { type GetExperimentQueryParams } from '@gonfalon/openapi/operations/getExperiment';

import { createQueryFetcher } from '../internal/createQueryFetcher';
import { getExperimentQuery } from '../queries/experiments';

export const fetchExperiment = createQueryFetcher(
  ({
    projectKey,
    environmentKey,
    experimentKey,
    params,
  }: {
    projectKey: string;
    environmentKey: string;
    experimentKey: string;
    params?: GetExperimentQueryParams;
  }) => getExperimentQuery({ projectKey, environmentKey, experimentKey, query: params }),
);
